<script setup lang="ts">
import { computed } from "vue";
import CrosstabCardOptions from "./CrosstabCardOptions.vue";
import FunnelCardOptions from "./FunnelCardOptions.vue";
import SankeyCardOptions from "./SankeyCardOptions.vue";
import OverlapCardOptions from "./OverlapCardOptions.vue";
import GeoMapCardOptions from "./GeoMapCardOptions.vue";
import WordCloudCardOptions from "./WordCloudCardOptions.vue";
import IPACardOptions from "./IPACardOptions.vue";
import KeyDriversCardOptions from "./KeyDriversCardOptions.vue";
import TurfCardOptions from "./TurfCardOptions.vue";
import KpiCardOptions from "./KpiCardOptions.vue";
import KpiTrendCardOptions from "./KpiTrendCardOptions.vue";
import CommentField from "./CardOptionFields/CommentField.vue";
import CustomNameTitleField from "./CardOptionFields/CustomNameTitleField.vue";
import { cardSubtype, cardTypeMeta } from "./constants";
import { useAnalysisContext } from "./analysisData";
import { analysisCardSubtitle } from "./analysisSubtitle";

const props = defineProps({
  card: { type: Object, required: true },
});

// One options panel per analysis sub_type (mirrors ANALYSIS_TYPES in constants).
const SUBTYPE_COMPONENTS = {
  crosstab: CrosstabCardOptions,
  funnel: FunnelCardOptions,
  sankey: SankeyCardOptions,
  overlap: OverlapCardOptions,
  geo_map: GeoMapCardOptions,
  word_cloud: WordCloudCardOptions,
  importance_performance: IPACardOptions,
  key_drivers: KeyDriversCardOptions,
  turf: TurfCardOptions,
  kpi: KpiCardOptions,
  kpi_trend: KpiTrendCardOptions,
};

const subtype = computed(() => cardSubtype(props.card));
const optionsComponent = computed(() => SUBTYPE_COMPONENTS[subtype.value] || null);
const defaultName = computed(() => cardTypeMeta(subtype.value)?.label || "");
const { availableCards, savedPopulations } = useAnalysisContext();
const defaultTitle = computed(() => analysisCardSubtitle(props.card, availableCards.value, savedPopulations.value));
const isKpi = computed(() => ["kpi", "kpi_trend"].includes(subtype.value));
</script>

<template>
  <template v-if="optionsComponent">
    <component :is="optionsComponent" :key="card.id" :card="card" />
    <CommentField :card="card" />
    <CustomNameTitleField
      :card="card"
      :default-name="defaultName"
      :default-title="defaultTitle"
      :description="isKpi" />
  </template>
</template>
